export default "__VITE_ASSET__Cxc4AuDK__"